module.exports = __webpack_public_path__ + "img/ImagePlaceholder.b5f6922b.jpg";